import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Check = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.621 7.229a1.295 1.295 0 0 1 0 1.83L14.762 37.93a1.294 1.294 0 0 1-1.83 0L.38 25.387a1.295 1.295 0 0 1 1.829-1.832l11.638 11.63L41.79 7.23a1.294 1.294 0 0 1 1.83 0Z"
  }));
});
Check.displayName = 'Check';
Check.defaultProps = {
  'aria-label': 'Check'
};
export default Check;